export enum DndItemType {
  CARD = "CARD",
}
